import { Drawer, Divider, Stack, Typography, useTheme, IconButton, Tabs, Tab, Paper } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { AnonymousUser, User } from "@/types";
import { useResponsive } from "@/hooks";
import { useState, useMemo } from "react";
import ViewCustomerTab from "./ViewCustomerTab";
import EditCustomerTab from "./EditCustomerTab";

const INITIAL_TAB = "view";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  client?: User | AnonymousUser;
  onUpdateClient?: (values: any) => void;
  isLoading?: boolean;
  setFieldValue?: (field: string, value: any) => void;
}

type TabKey = "view" | "edit";

const CustomerDrawer = ({ isOpen, onClose, client, onUpdateClient, isLoading, setFieldValue }: Props) => {
  const [activeTab, setActiveTab] = useState<TabKey>(INITIAL_TAB);
  const { palette } = useTheme();
  const { isMobile } = useResponsive();

  const tabs = useMemo(
    () => ({
      view: {
        label: "Ver",
        component: <ViewCustomerTab client={client!} />,
      },
      edit: {
        label: "Editar",
        component: <EditCustomerTab values={client} onUpdateClient={onUpdateClient} isLoading={isLoading} setFieldValue={setFieldValue!} onClose={onClose} />,
      },
    }),
    [client, onUpdateClient, isLoading, setFieldValue]
  );

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor="right"
      slotProps={{
        paper: {
          sx: {
            width: isMobile ? "100%" : "50%",
            bgcolor: "#DCEAFD",
          },
        },
      }}
    >
      <Stack sx={{ height: "100%" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2, pb: 0 }}>
          <Typography variant="h3">Cliente</Typography>

          <Paper sx={{ borderRadius: "50%" }}>
            <IconButton onClick={onClose}>
              <HugeiconsIcon icon={Cancel01Icon} color={palette.primary.main} />
            </IconButton>
          </Paper>
        </Stack>

        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{ px: 2 }}>
          {Object.entries(tabs).map(([key, t]) => (
            <Tab key={key} value={key} label={t.label} />
          ))}
        </Tabs>

        <Divider />

        <Stack flex={1} px={2} py={2} overflow="auto">
          {tabs[activeTab].component}
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default CustomerDrawer;
